import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  title: 'Plan Maestro 12 Meses',
  detail: 'Calendario anual listo para imprimir'
}, {
  title: 'Kit de Evaluación PRO',
  detail: 'Rúbricas + Exámenes + Diagnóstico Inicial'
}, {
  title: 'Guiones de Clase "Cero Dudas"',
  detail: '30 scripts listos para la cancha'
}];
export function BonusesSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-10 md:py-20 bg-polo-navyLight relative overflow-hidden" data-id="element-13">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-polo-gold/50 to-transparent" data-id="element-14" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-6 md:mb-10" data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-2 md:mb-3 text-gradient-gold" data-id="element-17">
            🎁 Bonos Exclusivos GRATIS
          </h2>
          <p className="text-sm md:text-base text-gray-400" data-id="element-18">
            Incluidos con tu compra — valor total:{' '}
            <span className="line-through" data-id="element-19">$29.990</span>
          </p>
        </div>

        <div className="glass-card rounded-xl p-4 md:p-6 border-polo-gold/20 mb-6 md:mb-8" data-id="element-20">
          <div className="space-y-3 md:space-y-4" data-id="element-21">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-22">
                <div className="shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-23">
                  <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-24" />
                </div>
                <div data-id="element-25">
                  <p className="text-base md:text-lg font-bold text-white leading-snug" data-id="element-26">
                    BONO {index + 1} — {bonus.title}
                  </p>
                  <p className="text-xs md:text-sm text-gray-400 mt-0.5" data-id="element-27">
                    {bonus.detail}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-28">
          <p className="text-xl md:text-2xl font-bold text-polo-gold mb-5 md:mb-6" data-id="element-29">
            Por el día de hoy → GRATIS
          </p>
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-polo-gold hover:bg-polo-goldHover text-polo-navy font-bold text-lg md:text-xl py-4 px-8 md:py-5 md:px-10 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all hover:scale-105 active:scale-95" data-id="element-30">
            👉 Quiero el pack completo + los bonos
          </button>
        </div>
      </div>
    </section>;
}